import React, { Component } from "react";

export default class Innovation extends Component {
  render() {
    return (
      <section className="section-innovation parallax">
        <div className="row">
          <div className="col-sm-12">
            <div className="text-box-bg-image">
              <h1>
                TOGETHER, WE CREATE INNOVATION
                THAT MATTERS
              </h1>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
